import { money, date, safeUrl } from "./domain";
import { download } from "./ui";
// Canvas produces a real downloadable PNG without uploading customer data.
export async function receiptPNG(
  order,
  store,
  label = false,
  autoDownload = true,
) {
  const lines = [];
  const push = (text, bold = false) => {
    let words = String(text).split(/\s+/),
      line = "";
    for (const w of words) {
      if ((line + w).length > 46) {
        lines.push([line, bold]);
        line = "";
      }
      line += w + " ";
    }
    lines.push([line.trim(), bold]);
  };
  push(label ? "ETIQUETA DE ENVÍO" : "RECIBO DE PEDIDO", true);
  push(order.number, true);
  push(`Creado: ${date(order.created_at)}`);
  push(`Emitido: ${date(new Date())}`);
  push(`Estado: ${order.status}`);
  push("");
  push(order.customer_name, true);
  push(order.phone);
  push(order.email);
  push(order.delivery === "pickup" ? "RECOJO EN TIENDA" : order.address);
  push("");
  for (const i of order.items) {
    push(`${i.quantity} × ${i.name}`, true);
    push(`Color: ${i.color} · Código: ${i.sku}`);
    if (!label) push(money(i.total));
  }
  if (!label) {
    push("");
    push(`Subtotal: ${money(order.subtotal)}`);
    push(`Envío: ${money(order.shipping)}`);
    push(`TOTAL: ${money(order.total)}`, true);
    push(`Forma de pago: ${order.payment}`);
    push("Recibo interno. No es comprobante fiscal.");
  }
  if (order.notes) push(`Nota: ${order.notes}`);
  const canvas = document.createElement("canvas");
  canvas.width = 760;
  canvas.height = 225 + lines.length * 34;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = "#713cc1";
  ctx.fillRect(0, 0, 760, 135);
  ctx.fillStyle = "#fff";
  ctx.font = "bold 38px Arial";
  ctx.fillText(store.name, 40, 78, 520);
  try {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = safeUrl(store.logo) || "/assets/logo.png";
    await img.decode();
    if (!store.logo || store.logo === "/assets/logo.png")
      ctx.drawImage(img, 991, 649, 1107, 1051, 612, 15, 110, 104);
    else {
      const scale = Math.min(110 / img.width, 104 / img.height);
      ctx.drawImage(
        img,
        612 + (110 - img.width * scale) / 2,
        15 + (104 - img.height * scale) / 2,
        img.width * scale,
        img.height * scale,
      );
    }
  } catch {}
  let y = 180;
  for (const [text, bold] of lines) {
    ctx.fillStyle = "#292132";
    ctx.font = `${bold ? "bold " : ""}24px Arial`;
    ctx.fillText(text, 40, y, 680);
    y += 34;
  }
  const blob = await new Promise((resolve) =>
    canvas.toBlob(resolve, "image/png"),
  );
  if (!blob) throw new Error("No se pudo crear la imagen del recibo.");
  if (autoDownload)
    download(blob, `${label ? "etiqueta" : "recibo"}-${order.number}.png`);
  return blob;
}
export function printReceipt() {
  window.print();
}
